<template>
  <div>
    <div class="active-form-container" v-show="!showLocation">
      <div class="active-form-header">
        <div v-if="!showGoodView" class="active-form-title">
          {{ textsByUserType.userInfoTitle }}
        </div>
        <div v-else class="active-form-title">填写信息</div>
        <div class="active-form-tip">{{ handleFormTip }}</div>
      </div>
      <div class="interval-line"></div>
      <div class="active-form-content" v-if="showGoodView">
        <!-- <customize-line :title="'经销商'" :required="false">
          <dropdown-search :inputValue="formData.dealer" :placeholder="'请填写与用户交易的经销商名称'" @dropDownChange="handleChannelSearch" @selectedData="handleSelectChannel" :itemList="channelList" />
        </customize-line> -->
        <customize-line
          :title="'公司名称'"
          :class="activeClass('company')"
          @click="updateActiveFormItem('company')"
        >
          <dropdown-search
            :inputValue="formData.company"
            :placeholder="'请输入公司名称'"
            @dropDownChange="handleFirmSearch"
            @selectedData="handleSelectFirm"
            :requiredPrompt="true"
            :promptText="'填写不规范，请选择完整公司名称'"
            :itemList="firmList"
            :field="'company'"
            @updateError="handleError"
          />
        </customize-line>
        <customize-line
          :title="'联系人'"
          :class="activeClass('contactPerson')"
          @click="updateActiveFormItem('contactPerson')"
        >
          <text-input
            v-model="contactPerson"
            :placeholder="'请输入联系人'"
            :allowLength="30"
            :allowWrap="false"
            :requiredPrompt="true"
            :promptText="'请输入完整的信息'"
            @update="hanldeUpdateContactPerson"
            :field="'contactPerson'"
            @updateError="handleError"
          />
        </customize-line>
        <customize-line
          :title="'联系电话'"
          :class="activeClass('telephone')"
          @click="updateActiveFormItem('telephone')"
        >
          <phone-input
            v-model="formData.telephone"
            :placeholder="'请输入联系电话'"
            @sendPhone="handleUpdateTelephone"
            :promptText="'填写不规范'"
            :field="'telephone'"
            @updateError="handleError"
          />
        </customize-line>
        <customize-line
          :required="false"
          :title="'所在区域'"
          @click="handleShowDistrictPicker"
          :class="activeClass('districtArr')"
        >
          <text-input
            v-model="district"
            :placeholder="'请选择公司所在地址'"
            :allowLength="30"
            :allowWrap="false"
            :field="'district'"
            :readonly="true"
          ></text-input>
          <div class="area-icon"></div>
        </customize-line>
        <div class="address">
          <customize-line
            :required="false"
            :title="'详细地址'"
            class="border-none"
            :class="activeClass('address')"
            @click="updateActiveFormItem('address')"
          >
            <text-input
              v-model="street"
              :allowWrap="false"
              :allowLength="50"
              @update="handleStreet"
            />
          </customize-line>
          <img
            src="@assets/images/position.png"
            alt=""
            class="address-btn"
            @click="handleShowLocation"
          />
        </div>
      </div>
      <template v-if="userType === 'engineer'">
        <div class="active-form-content" v-if="!showGoodView">
          <customize-line
            :title="'经销商'"
            :required="false"
            :class="activeClass('dealer')"
            @click="updateActiveFormItem('dealer')"
          >
            <dropdown-search
              :inputValue="formData.dealer"
              :placeholder="'请填写与用户交易的经销商名称'"
              @dropDownChange="handleChannelSearch"
              @selectedData="handleSelectChannel"
              :itemList="channelList"
            />
          </customize-line>
        </div>
        <div class="interval-line"></div>
      </template>
      <div class="active-form-content" v-if="!showGoodView">
        <customize-line
          :title="'公司名称'"
          :class="activeClass('company')"
          @click="updateActiveFormItem('company')"
        >
          <template v-slot:title>
            <div class="name-type">
              <div @click="handleShowCustomerTypePicker">
                {{ nameType === 'company' ? '公司名称' : '个体名称' }}
              </div>
              <div class="icon"></div>
            </div>
          </template>
          <dropdown-search
            v-if="nameType === 'company'"
            :inputValue="formData.company"
            :placeholder="
              `请填写${nameType === 'company' ? '所在公司名称' : '个体名称'}`
            "
            @dropDownChange="handleFirmSearch"
            @selectedData="handleSelectFirm"
            :requiredPrompt="true"
            :promptText="'填写不规范，请选择完整公司名称'"
            :itemList="firmList"
            :field="'company'"
            :autoFocus="true"
            @updateError="handleError"
          />
          <text-input
            v-else
            v-model="formData.company"
            :placeholder="'请填写个体名称'"
            :allowLength="30"
            :allowWrap="false"
            :requiredPrompt="true"
            :promptText="'请输入完整的信息'"
            @update="hanldeUpdateCompany"
            :field="'company'"
            @updateError="handleError"
          />
        </customize-line>
        <customize-line
          :title="'联系人'"
          :class="activeClass('contactPerson')"
          @click="updateActiveFormItem('contactPerson')"
        >
          <text-input
            v-model="contactPerson"
            :placeholder="'请填写设备运维人员名称'"
            :allowLength="30"
            :allowWrap="false"
            @update="hanldeUpdateContactPerson"
            :field="'contactPerson'"
            @updateError="handleError"
            :requiredPrompt="true"
            :promptText="'请输入完整的信息'"
          />
        </customize-line>
        <customize-line
          :title="'联系方式'"
          :class="activeClass('telephone')"
          @click="updateActiveFormItem('telephone')"
        >
          <phone-input
            v-model="formData.telephone"
            :placeholder="'请填写设备运维人员电话'"
            @sendPhone="handleUpdateTelephone"
            :promptText="'填写不规范'"
            :field="'telephone'"
            @updateError="handleError"
          />
        </customize-line>
        <customize-line-group>
          <template v-slot:line>
            <customize-line
              :title="'所在地区'"
              :class="activeClass('districtArr')"
              @click="handleShowDistrictPicker"
            >
              <text-input
                v-model="district"
                :placeholder="'请选择设备安装的区域'"
                :allowLength="30"
                :allowWrap="false"
                :field="'district'"
                :readonly="true"
              ></text-input>
              <div class="area-icon"></div>
            </customize-line>
            <div class="address">
              <customize-line
                :title="'详细地址'"
                class="border-none"
                :class="activeClass('address')"
                @click="updateActiveFormItem('address')"
              >
                <text-input
                  :placeholder="'请填写设备安装的详细地址'"
                  v-model="street"
                  :allowLength="50"
                  :allowWrap="true"
                  @update="handleStreet"
                  :requiredPrompt="true"
                  :promptText="'请输入完整的信息'"
                  :field="'address'"
                  @updateError="handleError"
                  @click="
                    e => {
                      e.preventDefault();
                      setAddressInputVisible(true);
                    }
                  "
                />
              </customize-line>
            </div>
          </template>
          <template v-slot:extra>
            <div class="location" @click="() => setMapVisible(true)">
              <img src="@assets/images/icon_location_primary.svg" />
              <span>定位</span>
            </div>
          </template>
        </customize-line-group>
      </div>

      <div class="active-form-footer">
        <customize-button
          :content="'获取激活码'"
          :type="disabled"
          :onClick="
            () => {
              if (userType === 'engineer') {
                confirmActiveCode();
              } else {
                handleActiveCode();
              }
            }
          "
        />
      </div>
      <district-picker
        ref="districtPicker"
        @select="handleSelectDistrict"
        :value="pickerDistrictArr"
        :language="language"
        :confirmTxt="'确认'"
        :cancelTxt="'取消'"
      />
      <customer-type-picker
        ref="customerTypePicker"
        @select="handleSelectNameType"
        @cancel="handleHideCustomerTypePicker"
        :value="nameType"
      />
      <global-dialog ref="dialog" />
    </div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="80%"
      :show-close="false"
      center
    >
      <span class="dialog-text">当前设备无法激活 (错误码 5001000)</span>
      <span class="dialog-text">请联系 400-168-9545</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <Location v-if="showLocation" />
    <address-input
      :visible="addressInputVisible"
      @back="() => setAddressInputVisible(false)"
      @selectPoi="handleSelectPoi"
      @confirm="handleAddressConfirm"
    />
    <amap
      :visible="mapVisible"
      @selectPoi="handleSelectPoi"
      @back="handleAmapBack"
    />
  </div>
</template>

<script>
import store from '@stores';
import Navigation from '@components/NewComponents/Navigation/Navigation.vue';
import CustomizeLine from '@components/NewComponents/CustomizeLine/CustomizeLine.vue';
import CustomizeLineGroup from '@components/NewComponents/CustomizeLineGroup/CustomizeLineGroup.vue';
import DropdownSearch from '@components/NewComponents/DropdownSearch/DropdownSearch.vue';
import CustomizeButton from '@components/NewComponents/CustomizeButton/CustomizeButton.vue';
import DistrictPicker from '@components/DistrictPicker/DistrictPicker.vue';
import CustomerTypePicker from '@components/CustomerTypePicker/CustomerTypePicker.vue';
import GlobalDialog from '@components/GlobalDialog/GlobalDialog.vue';
import AddressInput from './AddressInput/AddressInput.vue';
import Location from '../Location/Location.vue';
import TextInput from './TextInput/TextInput.vue';
import PhoneInput from './PhoneInput/PhoneInput.vue';
import { getFirmLists, getActiveParams } from '../DataManager';
import Apis from '@model';
import { trackActiveEvent } from '../../../utils/tools/_track';
import { formatAddress } from '../../../utils/formatAddress';
// 已迁移至百度地图
import bmapService, { BMAP_CONTAINER_ID } from '@stores/location/bmap';
import Amap from '../Amap/Amap.vue';
import warningIcon from '@assets/images/icon_warning.svg';

export default _extend({
  name: 'ActiveForm',
  data() {
    const {
      dealer,
      contactPerson,
      company,
      districtArr,
      telephone,
      street
    } = this.$store.state.form.formInfo;
    const { noReportCode } = this.$store.state.form;
    return {
      language: 'zh_CN', // 当前版本去掉多语言，只有简体中文
      promptType: noReportCode ? '' : 'reportCode',
      pickerDistrictArr: [],
      districtArr: districtArr,
      firmList: [],
      channelList: [],
      disabled: -1,
      street: street,
      contactPerson: contactPerson,
      completeContactCompany: company.length < 2,
      centerDialogVisible: false,
      showGoodView: false,
      activeFormItem: '',
      errorFormItems: [],
      nameType: 'company',
      formData: {
        dealer: dealer,
        company: company,
        contactPerson: contactPerson,
        telephone: telephone,
        districtArr: districtArr,
        street: street
      },
      district: '',
      addressInputVisible: false,
      BMAP_CONTAINER_ID,
      mapVisible: false,
      amapInstance: bmapService // 保持变量名兼容
    };
  },
  components: {
    Navigation,
    CustomizeLine,
    CustomizeLineGroup,
    DropdownSearch,
    CustomizeButton,
    DistrictPicker,
    CustomerTypePicker,
    GlobalDialog,
    Location,
    TextInput,
    PhoneInput,
    AddressInput,
    Amap
  },
  methods: {
    handleError(key, state = false) {
      const index = this.errorFormItems.indexOf(key);
      if (index === -1 && state) {
        this.errorFormItems.push(key);
      } else if (index !== -1 && !state) {
        this.errorFormItems.splice(index, 1);
      }
    },
    updateActiveFormItem(value) {
      this.activeFormItem = value;
    },
    activeClass(value) {
      if (this.errorFormItems.includes(value)) {
        return { error: true };
      }
      if (this.activeFormItem === value) {
        return { active: true };
      }
    },
    getLocation(cb) {
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          position => {
            cb(position);
          },
          () => {
            // 获取自动定位失败
            this.allowPosition = false;
          },
          {
            enableHighAccuracy: true
          }
        );
      }
    },
    handleShowDistrictPicker() {
      this.updateActiveFormItem('districtArr');
      this.$refs.districtPicker.show();
    },
    handleShowCustomerTypePicker() {
      this.$refs.customerTypePicker.show();
    },
    handleHideCustomerTypePicker() {
      this.$refs.customerTypePicker.hide();
    },
    handleShowLocation() {
      this.$store.commit(store.VX_TYPES.FORM.UPDATE_SHOW_LOCATION, true);
    },
    async handleFirmSearch(value) {
      value = value ? value.trim() : value;
      this.formData.company = value;
      this.completeContactCompany = value.length < 2;
      this.detectForm();
      if (!value) {
        this.firmList = [];
        return;
      }
      const data = await getFirmLists(value);
      if (data && data.length) {
        this.firmList = data.slice(0, 10);
      }
    },
    async handleChannelSearch(value) {
      value = value ? value.trim() : value;
      this.formData.dealer = value;
      this.detectForm();
      if (!value) {
        this.channelList = [];
        return;
      }
      const data = await getFirmLists(value);
      if (data && data.length) {
        this.channelList = data.slice(0, 10);
      }
    },
    handleSelectFirm(value) {
      this.formData.company = value;
      this.detectForm();
    },
    handleSelectChannel(value) {
      this.formData.dealer = value;
      this.detectForm();
    },
    hanldeUpdateCompany(value) {
      this.formData.company = value;
      this.detectForm();
    },
    hanldeUpdateContactPerson(value) {
      this.formData.contactPerson = value;
      this.detectForm();
    },
    handleUpdateTelephone(value) {
      this.formData.telephone = value;
      this.detectForm();
    },
    handleSelectDistrict(districtArr) {
      this.districtArr = [...districtArr];
      if (this.districtArr.slice(0, 2).every(item => item)) {
        this.formData.districtArr = this.districtArr;
        this.district = this.districtArr.join(' ');
      } else {
        this.district = '';
      }
      this.pickerDistrictArr = this.districtArr;
      setTimeout(() => {
        this.detectForm();
      }, 0);
    },
    handleStreet(val) {
      this.formData.street = val;
      this.street = val;
      this.detectForm();
    },
    handleFormatAddress() {
      if (!this.showGoodView && this.formData.street) {
        const { province, city, area, details } = formatAddress(
          this.formData.street
        );
        details && this.handleStreet(details);
        if (this.notFoundAddress([province, city, area])) {
          return;
        }
        if (this.modifyDistrictArr([province, city, area])) {
          return;
        }
        this.handleSelectDistrict([province, city, area]);
      }
    },
    modifyDistrictArr([province, city, area]) {
      const [oldProvince, oldCity, oldArea] = this.districtArr;
      if (
        (province && oldProvince && oldProvince !== province) ||
        (city && oldCity && oldCity !== city) ||
        (area && oldArea && oldArea !== area)
      ) {
        const message = `您选择的地址可能是属于${province}${city}${area}，是否切换`;

        this.$alert(message, {
          confirmButtonText: '是',
          cancelButtonText: '否',
          showCancelButton: true,
          customClass: 'custom-alert',
          showClose: false,
          dangerouslyUseHTMLString: true,
          cancelButtonClass: 'custom-cancel-button'
        }).then(() => {
          this.handleSelectDistrict([province, city, area]);
        });
        return true;
      }
      return false;
    },
    notFoundAddress([province, city, area]) {
      if (!province || !city || !area) {
        let notFoundLevel = '';

        if (!province) {
          notFoundLevel = '省份';
        } else if (!city) {
          notFoundLevel = '城市';
        } else if (!area) {
          notFoundLevel = '行政区';
        }
        const h = this.$createElement;
        const notFoundAddressVNode = h('div', [
          h('div', { class: 'custom-alert-icon' }, [
            h('img', { attrs: { src: warningIcon } })
          ]),
          h(
            'div',
            {
              class: 'custom-alert-content'
            },
            `未找到对应的${notFoundLevel}，请您手动进行选择哦`
          )
        ]);
        this.$alert(notFoundAddressVNode, {
          confirmButtonText: '我知道了',
          customClass: 'custom-alert',
          showClose: false,
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.handleSelectDistrict([province, city, area]);
          setTimeout(() => {
            this.handleShowDistrictPicker();
          }, 0);
        });
        return true;
      }
      return false;
    },
    handleDistrict(val) {
      if (val) {
        this.handleError('district', false);
      } else {
        this.handleError('district', true);
      }
    },
    handleSelectNameType(type) {
      this.nameType = type;
      this.formData.company = '';
      this.firmList = [];
      this.handleError('company', false);
      this.detectForm();
    },
    detectForm() {
      if (!this.formData['telephone']) {
        this.disabled = -1;
        return false;
      }
      if (!this.formData['company']) {
        this.disabled = -1;
        return false;
      }
      if (this.errorFormItems.length) {
        this.disabled = -1;
        return false;
      }
      // 这段逻辑太糟糕了，上面先拦截修改过的校验
      const keys = Object.keys(this.formData);
      for (const key of keys) {
        if (key === 'districtArr' && !this.showGoodView) {
          if (!this.districtArr.length) {
            this.disabled = -1;
            return false;
          }
        } else if (
          this.formData[key].toString().replace(/[\r\n]/g, '') === '' &&
          key !== 'dealer' &&
          key !== 'districtArr' &&
          key !== 'street'
        ) {
          this.disabled = -1;
          return false;
        } else if (key === 'street' && !this.showGoodView) {
          if (!this.formData.street) {
            this.disabled = -1;
            return false;
          }
        }
        if (key === 'contactPerson' || key === 'company' || key === 'street') {
          if (this.formData[key].length < 2) {
            this.disabled = -1;
            return false;
          }
        }
      }
      this.disabled = 0;
    },
    confirmActiveCode() {
      this.$alert('为保证后续服务的正确运行，请确保公司名称准确无误', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showCancelButton: true,
        customClass: 'custom-alert',
        showClose: false,
        dangerouslyUseHTMLString: true,
        cancelButtonClass: 'custom-cancel-button'
      }).then(() => {
        this.handleActiveCode();
      });
    },
    async handleActiveCode() {
      const { originData } = this.$store.state.form;
      const { sn, pcsn, baseParam, extra } = getActiveParams();
      const isLimit = await this.handleLimitActiveArea();
      if (!isLimit) return;

      this.$refs.dialog.dialogShow(1);
      Apis.getActiveCode(
        this.promptType,
        sn,
        pcsn,
        'token',
        this.formData,
        originData,
        baseParam,
        extra
      ).then(res => {
        const { result, code } = res;
        if (result === 'success') {
          trackActiveEvent('h5_get_code', this.$pushData, this.formData);
          // 成功获取激活码
          this.$refs.dialog.hide();
          this.$store.commit(store.VX_TYPES.FORM.UPDATE_ACTIVE_CODE, code);
          this.$store.commit(
            store.VX_TYPES.FORM.UPDATA_EXIST_ACTIVE_CODE,
            true
          );
          this.$router.push(`/v2/ActiveCode/?${window.location.search}`);
        } else if (result === 'timeout') {
          // 请求超时
          this.$refs.dialog.dialogShow(0);
          this.$refs.dialog.toggle();
        }
      });
    },
    getQueryString(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    async handleLimitActiveArea() {
      try {
        this.$refs.dialog.dialogShow(1);
        if (!this.amapInstance.currentLocation.addressComponent) {
          throw new Error('定位失败');
        }
        const {
          province,
          city,
          districe
        } = this.amapInstance.currentLocation.addressComponent;
        const isChina = !!(province + city + districe);
        if (isChina) {
          // 在中国区域内，允许激活
          return true;
        } else {
          this.$refs.dialog.hide();
          // 显示不允许激活弹窗
          // alert('该区域不允许激活');
          this.centerDialogVisible = true;
          return false;
        }
      } catch (error) {
        // 定位失败，无法判断原因，允许激活
        return true;
      }
    },
    setAddressInputVisible(val) {
      this.addressInputVisible = val;
    },
    setMapVisible(val) {
      this.mapVisible = val;
      // 兜底：点击定位按钮时再次请求定位权限
      if (val && this.amapInstance) {
        this.amapInstance.getCurrentPosition();
      }
    },
    handleSelectPoi(poi) {
      const { pname, cityname, adname, address, name } = poi;
      this.setMapVisible(false);
      this.setAddressInputVisible(false);
      this.handleStreet(address + name);
      this.updateActiveFormItem('');
      if (this.modifyDistrictArr([pname, cityname, adname])) {
        return;
      }
      this.handleSelectDistrict([pname, cityname, adname]);
    },
    handleAmapBack() {
      this.setMapVisible(false);
      this.setAddressInputVisible(false);
      this.updateActiveFormItem('');
    },
    handleAddressConfirm(val) {
      this.setMapVisible(false);
      this.setAddressInputVisible(false);
      this.updateActiveFormItem('');
      this.handleStreet(val);
      this.handleFormatAddress();
    }
  },
  created() {
    const softwareBrand = this.getQueryString('softwareBrand');
    if (softwareBrand && softwareBrand.toLocaleLowerCase() === 'goodview') {
      this.showGoodView = true;
    } else {
      this.showGoodView = false;
    }
  },
  computed: {
    addressStreet() {
      return this.$store.state.form.locationStreet;
    },
    showLocation() {
      return this.$store.state.form.showLocation;
    },
    handleFormTip() {
      return this.showGoodView
        ? '为了提供更好的服务，我们需要您填写以下信息'
        : this.textsByUserType.userInfoTips;
    },
    // district() {
    //   if (this.districtArr.slice(0, 2).every(item => item)) {
    //     this.formData.districtArr = this.districtArr;
    //     return this.districtArr.join(' ');
    //   }
    //   return '';
    // },
    updateAddress() {
      return (
        this.$store.state.form.address.province +
        ' ' +
        this.$store.state.form.address.city +
        ' ' +
        this.$store.state.form.address.district
      );
    },
    userType() {
      return this.getQueryString('userType') || 'user';
    },
    textsByUserType() {
      const userType = this.getQueryString('userType') || 'user';
      const TEXTS = {
        user: {
          userInfoTitle: '用户信息',
          userInfoTips: '填写完整的使用信息，提交获取激活码'
        },
        engineer: {
          userInfoTitle: '客户信息',
          userInfoTips: '填写完整的客户信息，提交获取激活码'
        }
      };
      return TEXTS[userType] || TEXTS['user'];
    }
  },
  watch: {
    addressStreet() {
      const { locationStreet } = this.$store.state.form;
      if (locationStreet !== '') {
        this.street = locationStreet;
        this.handleStreet(locationStreet);
        this.handleError('address', false);
        this.detectForm();
      }
    },
    updateAddress() {
      this.districtArr = [
        this.$store.state.form.address.province,
        this.$store.state.form.address.city,
        this.$store.state.form.address.district
      ];
      this.$refs.addressArea.innerText =
        this.$store.state.form.address.province +
        ' ' +
        this.$store.state.form.address.city +
        ' ' +
        this.$store.state.form.address.district;
    },
    district() {
      if (this.district[1]) {
        this.amapInstance.placeSearch.setPageSize(10);
        this.amapInstance.placeSearch.setCity(this.formData.districtArr[1]);
      } else {
        this.amapInstance.resetPlacesearchCity();
      }
    }
  },
  beforeMount() {
    this.amapInstance.init();
  },
  mounted() {
    const installCodeDistrictArr = this.$store.state.form.formInfo.districtArr;
    if (installCodeDistrictArr) {
      this.handleSelectDistrict(installCodeDistrictArr);
    }
    this.detectForm();
  }
});
</script>

<style lang="scss" scoped>
@import './ActiveForm.scss';
</style>

<style lang="scss">
.custom-alert {
  width: 320px;
  border-radius: 8px;
  border: 0;
  .el-message-box__header {
    display: none;
  }
  .el-message-box__content {
    padding: 27px 16px;
    font-size: 16px;
    text-align: center;
    color: #333;
    .custom-alert-icon {
      width: 40px;
      height: 40px;
      margin: 0 auto 12px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .el-message-box__btns {
    display: flex;
    justify-content: center;
    padding: 0 0 12px 0;
    .el-button {
      width: 114px;
      height: 40px;
      font-size: 16px;
      color: #fff;
      background-color: #4981f2;
      border-radius: 4px;
      font-weight: normal;
    }
    .custom-cancel-button {
      background-color: rgba(26, 29, 38, 0.08);
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/business/views/ActiveForm/ActiveForm.vue